import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Homes from './Pages/Home/Homes';

import BlogDetails from './Blogs copy/BlogDetails';
import BlogList from './Blogs copy/BlogList';
import { blogs } from './Blogs copy/BlogData';




function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homes />} />
        <Route path="/home" element={<Homes />} />
       
      

        <Route path="/blog/:title" element={<BlogDetails />} />
        <Route  path="/blogs" element={<BlogList blogs={blogs} count={100000000000}/>}/>


    
        </Routes>
    </Router>
  );
}

export default App;
